import { render, staticRenderFns } from "./PersistRelatorioEntregaView.vue?vue&type=template&id=91411706&"
import script from "./PersistRelatorioEntregaView.vue?vue&type=script&lang=ts&"
export * from "./PersistRelatorioEntregaView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports